import axios from "axios"
import store from "@/store"

var isLocal = location.hostname.indexOf("localhost") > -1
var baseURL = isLocal 
  ? process.env.VUE_APP_API_BASE_URL_LOCAL
  : process.env.VUE_APP_API_BASE_URL_PROD

function request() {
  return new Promise(resolve => {
    resolve(
      axios.create({
        baseURL,
        headers: { "Content-Type": "application/json", auth: JSON.stringify(store.state.user) }
      })
    )
  })
}

export default {
  baseURL,
  getSignedURL: baseURL + "get-signed-url",
  s3URL: process.env.VUE_APP_S3_URL,
  request: function(method, name, data = {}) {
    return new Promise((resolve, reject) => {
      request().then(req =>
        req[method](name, data)
          .then(response => {
            resolve(response.data)
          })
          .catch(error => {
            reject(error)
          })
      )
    })
  },
  geocode: function(address) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          process.env.VUE_APP_GOOGLE_MAPS_BASE_URL +
            encodeURIComponent(address) +
            "&key=" + process.env.VUE_APP_GOOGLE_MAPS_API_KEY
        )
        .then(function(response) {
          resolve(response.data)
        })
        .catch(function(error) {
          reject(error)
        })
    })
  }
}
